import {AfterViewInit, Component, ElementRef, EventEmitter, OnDestroy, Output, ViewChild} from '@angular/core';
import {Router} from '@angular/router';
import {CalEvent} from "../utils/model/CalEvent";
import {CalendarDialogDelete} from "../dialog-delete/dialog-delete.component";
import {CalendarEvent} from "../model/CalendarEvent";
import {CalendarUtils} from "../CalendarUtils";
import {CalendarService} from "../calendar.service";
declare let $: any;

@Component({
  selector: 'app-dialog-view',
  templateUrl: './dialog-view.component.html',
  styleUrls: ['./dialog-view.component.scss']
})
export class CalendarDialogViewComponent implements AfterViewInit, OnDestroy {
  @Output() onChange = new EventEmitter();
  @ViewChild('modalView') modalView!: ElementRef;
  @ViewChild('dialogRemove') viewDeleteModal!: CalendarDialogDelete;
  calendarEvent?: CalendarEvent;
  calEvent?: CalEvent | any;
  maxHeight?: number;
  titleOverlay: boolean = false;
  private _showModal: boolean = false;
  private _targetEl?: HTMLElement;
  private _jsEvent?: MouseEvent;
  private _timer: any;
  private _scrollTimer: any;
  private _$modalView: any;
  private _onChange?: Function;

  constructor(private router: Router, private calendarService: CalendarService) {
  }

  ngAfterViewInit() {
    this._initModalView();
    this._addScrollUpdatePos();
  }

  ngOnDestroy() {
    this._destroyModalView();
    this._removeScrollUpdatePos();
  }

  editEvent() {
    this.hide();
    if (this.calendarEvent && this.calendarEvent.event.uuid) {
      this.calendarService.changeEventCalender(this.calendarEvent.event.uuid);
    }
  }

  changeEvent($event: any) {
    this.hide();
    this.onChange.emit();
    if (this._onChange) {
      this._onChange();
    }
  }

  viewEvent(event: CalEvent, jsEvent: MouseEvent, target: HTMLElement, onChange: Function) {
    this._onChange = onChange;
    this.calendarEvent = new CalendarEvent(event);
    this.calEvent = event;
    this._targetEl = target;
    this._jsEvent = jsEvent;
    this._syncBodyHeight();
    this._preventScrolling();
    jsEvent.stopPropagation();
    setTimeout(() => this._openModal(jsEvent, target), 100)
  }

  hide() {
    this._showModal = false;
    this._$modalView.hide();
    this._$modalView.css('opacity', 0);
  }

  show() {
    this._showModal = true;
    this._$modalView.show();
  }

  removeEvent() {
    this.viewDeleteModal.show();
  }

  private _preventScrolling() {
    $(document.scrollingElement).css('overflow', 'hidden');
    clearTimeout(this._scrollTimer);
    this._scrollTimer = setTimeout(() => {
      $(document.scrollingElement).css('overflow', '');
    }, 600);
  }

  private _syncBodyHeight() {
    this.maxHeight = innerHeight - 150;
  }

  private _initModalView() {
    this._$modalView = $(this.modalView.nativeElement).hide();

    // Click outside to close
    this.hide = this.hide.bind(this);
    document.body.addEventListener('click', this.hide);

    // Prevent close
    this._$modalView.on('click', (e: any) => e.stopPropagation());

    // Append modal to body
    $(document.body).append(this._$modalView);
  }

  private _destroyModalView() {
    document.body.removeEventListener('click', this.hide);
    this._$modalView.remove();
  }

  private _addScrollUpdatePos() {
    this._scrollUpdatePos = this._scrollUpdatePos.bind(this);
    document.addEventListener('scroll', this._scrollUpdatePos, true);
  }

  private _removeScrollUpdatePos() {
    document.removeEventListener('scroll', this._scrollUpdatePos);
  }

  private _scrollUpdatePos() {
    // Delay update pos for performance
    if (this._showModal && this._jsEvent && this._targetEl) {
      clearTimeout(this._timer);
      this._timer = setTimeout(() => {
        if (this._targetEl)
          this._openModal(this._jsEvent, this._targetEl)
      }, 100);
    }
  }

  private _openModal(jsEvent: any, target: HTMLElement) {
    // Show to get real size
    this.show();

    let pos = CalendarUtils.computePosByTargetEl(this.modalView.nativeElement, target, jsEvent);

    let transformCss = 'translate3d(' + pos.left + 'px,' + pos.top + 'px,0)';
    // Use transform translate3d to boot performance
    const css: any = {
      '-webkit-transition-duration': '300ms',
      'transition-duration': '300ms',
      'opacity': '1',
      '-webkit-transform': transformCss,
      'transform': transformCss,
    };
    this._$modalView.css(css);
  }

}
